
    <li>
      <span class="filename" [textContent]="fileName"></span>
      <progress class='getValue' [hidden]="completed" max="100" [value]="value">{{value}}</progress>
      <span class="upload-completed" *ngIf="completed || error">
      <op-icon icon-classes="icon-close" *ngIf="error"></op-icon>
      <op-icon icon-classes="icon-checkmark" *ngIf="completed"></op-icon>
    </span>
    </li>
  